import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import ReactDOM from "react-dom";

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);

const envIsDevelopment = () => {
  return !process.env.NODE_ENV || process.env.NODE_ENV === "development";
};

function render() {
  const App = require("./app/App").default;
  ReactDOM.render(<App />, document.getElementById("root"));
}

render();

if (envIsDevelopment() && module.hot) {
  module.hot.accept("./app/App", render);
}
